module.exports = __webpack_public_path__ + "img/shape_roulette_anime.ce0a5b59.gif";